<p>integration-details works!</p>
